module.exports = __webpack_public_path__ + "static/media/ic_blast_msg.beb5e721.svg";